// extracted by mini-css-extract-plugin
export default {"price-icon":"PriceTooltip__price-icon--m8yr4","tooltip":"PriceTooltip__tooltip--fmV97"};